export default () => {
  const popularTags = document.querySelectorAll('.popular-tags-tag'),
        moreBtn = document.querySelector('.popular-tags-more');

  if (!popularTags.length || !moreBtn) {
    return;
  }

  moreBtn.addEventListener('click', () => {
    popularTags.forEach(item => {
      item.classList.remove('tag-hidden');
    });
    moreBtn.remove();
  })
}